import React from "react";
import APP_ENV from "../../Environment";

export function SignUpModal(props) {
    const cv_site_url = `${APP_ENV.CV_SITE_URL}signup`;
    const hrefLink = null;
    return (
        <>
            <div className="modalwin">
                <div className="inner">
                    <img src={require("../../images/login/del.svg")} alt="del" className="del"
                         onClick={props.toggleOpenSignUpModal} width="50" height="100"/>
                    <h3 className="modaltitle">検査キット種別の選択</h3>
                    <ul className="modallist">
                        <li>
                            <a href={hrefLink} onClick={props.changeStateSignInFunc}>
                                <div className="modalkitwrap">
                                    <img src={require("../../images/login/gepackage1.png")} alt="遺伝子検査"
                                         className="modalkit"/>
                                    <img src={require("../../images/login/gepackage2.png")} alt="遺伝子検査"
                                         className="modalkit"/>
                                </div>
                                <div>
                                    遺伝子検査
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href={cv_site_url}>
                                <div className="modalkitwrap"><img src={require("../../images/login/coronakit_tn.png")}
                                                               alt="遺伝子検査" className="modalkit"/>
                                </div>
                                新型コロナウィルスPCR検査
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="overlay"/>
        </>
    );
}
